
import { Domain } from '../../apis/mgmt/api';
import { readOnly } from '../common/DataView';
import { ListProps, ListWithCreateButtonLayout } from '../common/List';
import { DomainCard } from './DomainCard';

export function DomainList(props: ListProps<Domain>) {

    const { onAddItem, onEditItem } = props;

    return (
        <ListWithCreateButtonLayout onCreateClick={onAddItem} >
            {props.data && props.data.map((itemData: Domain, index: number) => (
                <DomainCard
                    key={itemData.id}
                    data={itemData} {...readOnly}
                    onClick={onEditItem}
                />
            ))}
        </ListWithCreateButtonLayout>
    );

}